import Nullstack from 'nullstack';
export default function IconSquareToggle({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-square-toggle",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("line", {
    x1: "12",
    y1: "2",
    x2: "12",
    y2: "22"
  }), "   ", Nullstack.element("path", {
    d: "M14 20h-8a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h8"
  }), "   ", Nullstack.element("path", {
    d: "M20 6a2 2 0 0 0 -2 -2"
  }), "   ", Nullstack.element("path", {
    d: "M18 20a2 2 0 0 0 2 -2"
  }), "   ", Nullstack.element("line", {
    x1: "20",
    y1: "10",
    x2: "20",
    y2: "14"
  }), " ");
}